<ng-container *transloco="let t">
  <div class="admin-card text-center">
    <div class="pb-3">
      <app-language-output [hrLabel]="event?.name" [srLabel]="event?.nameSr" [enLabel]="event?.nameEng" [itLabel]="event?.nameIta"
                              [siLabel]="event?.nameSlo" [bsLabel]="event?.nameBs" [languages]="languages"/>
    </div>

    <section>
      <p><small>{{event?.start | localizedDate:'short'}}</small></p>
      <app-rounded-button [label]="t('timing.overview.and.results')" [btnClass]="'rounded-button--black-outline'"
                          [fullWidth]="true"><i class="bi bi-bar-chart pe-2"></i>
      </app-rounded-button>
    </section>

    <section class="pt-4">
      @for(waypoint of waypoints; track waypoint) {
      @if(waypoint.waypointTypeId !== WaypointType.START_WAYPOINT) {
      <div class="pb-2">
        <app-rounded-button
        [btnClass]="'rounded-button' + (waypoint.waypointTypeId === WaypointType.FINISH_WAYPOINT ? '--solid' : '--light-blue')"
        [fullWidth]="true" (onClick)="goToTimer(waypoint)">
                      @if(waypoint.waypointTypeId === WaypointType.FINISH_WAYPOINT) {
                          <i class="bi bi-stop-fill pe-2"></i>
      }
                       <app-language-output [hrLabel]="waypoint.pointNameHr" [enLabel]="waypoint.pointNameEn"
                                     [itLabel]="waypoint.pointNameIt" [siLabel]="waypoint.pointNameSlo" [srLabel]="waypoint.pointNameSr" [bsLabel]="waypoint.pointNameBs"
                                     [defaultLanguage]="event?.defaultLanguage"
                                     [languages]="languages"/>
        </app-rounded-button>
      </div>
      }
      }

    </section>
  </div>
  <div class="my-4 horizontal-separator"></div>
  <section>
    <div class="pb-2">
      <app-rounded-button [label]="t('app.common.back')" [btnClass]="'rounded-button--black-outline'" (onClick)="back()"
                          [fullWidth]="true">
        <i class="bi bi-box-arrow-left pe-2"></i>
      </app-rounded-button>
    </div>
    <app-rounded-button [label]="t('timing.clear.cache.confirmation.title')" [btnClass]="'rounded-button--solid'" [fullWidth]="true" (onClick)="deleteCache()" >
      <i class="bi bi-eraser pe-2"></i>
    </app-rounded-button>
  </section>
</ng-container>
